import { Fragment, type ReactNode } from 'react';

/**
 * Zeigt KI-Antworten lesbar an: Absätze, Listen, Überschriften, **fett**, `Code`.
 * Alles wird als Text gesetzt (kein HTML) – Links werden nicht anklickbar gemacht.
 */
export function KiText({ text }: { text: string }) {
  const bloecke: ReactNode[] = [];
  const zeilen = text.replace(/\r\n?/g, '\n').split('\n');
  let liste: { geordnet: boolean; punkte: string[] } | null = null;
  let absatz: string[] = [];

  const absatzFertig = () => {
    if (absatz.length) bloecke.push(<p key={bloecke.length}>{zeilenMitUmbruch(absatz)}</p>);
    absatz = [];
  };
  const listeFertig = () => {
    if (liste) {
      const punkte = liste.punkte.map((p, i) => <li key={i}>{inline(p)}</li>);
      bloecke.push(liste.geordnet ? <ol key={bloecke.length}>{punkte}</ol> : <ul key={bloecke.length}>{punkte}</ul>);
    }
    liste = null;
  };

  for (const z of zeilen) {
    const punkt = /^\s*[-*•]\s+(.*)$/.exec(z);
    const nummer = /^\s*\d+[.)]\s+(.*)$/.exec(z);
    const kopf = /^\s*#{1,4}\s+(.*)$/.exec(z);
    if (punkt || nummer) {
      absatzFertig();
      const geordnet = !!nummer;
      if (!liste || liste.geordnet !== geordnet) {
        listeFertig();
        liste = { geordnet, punkte: [] };
      }
      liste.punkte.push((punkt ?? nummer)![1]!);
    } else if (kopf) {
      absatzFertig();
      listeFertig();
      bloecke.push(<p key={bloecke.length} className="ki-zwischentitel">{inline(kopf[1]!)}</p>);
    } else if (!z.trim()) {
      absatzFertig();
      listeFertig();
    } else {
      listeFertig();
      absatz.push(z);
    }
  }
  absatzFertig();
  listeFertig();
  return <div className="ki-text">{bloecke}</div>;
}

function zeilenMitUmbruch(zeilen: string[]): ReactNode {
  return zeilen.map((z, i) => (
    <Fragment key={i}>
      {i > 0 && <br />}
      {inline(z)}
    </Fragment>
  ));
}

function inline(t: string): ReactNode {
  const teile = t.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return teile.map((s, i) => {
    if (s.startsWith('**') && s.endsWith('**') && s.length > 4) return <strong key={i}>{s.slice(2, -2)}</strong>;
    if (s.startsWith('`') && s.endsWith('`') && s.length > 2) return <code key={i}>{s.slice(1, -1)}</code>;
    return <Fragment key={i}>{s}</Fragment>;
  });
}
